// Page title block, then ONE toolbar row for every register in the same order:
// search → filters → columns → import / export → bulk actions → primary action (always last, pinned right).
export const PageHeader = ({ title, subtitle, children, testid }) => (
  <div className="mb-4" data-testid={testid}>
    <div className="min-w-0">
      <h1 className="text-title">{title}</h1>
      {subtitle && <p className="text-muted-foreground text-[12px] mt-0.5 leading-snug">{subtitle}</p>}
    </div>
    {children && (
      <div className="mt-3 flex flex-wrap items-center gap-2 [&>*:last-child]:ml-auto" data-testid="page-toolbar">
        {children}
      </div>
    )}
  </div>
);
